export const GLOBAL_MODAL = 'global-modals'
